var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('v-server-table',{attrs:{"columns":_vm.columns,"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }